var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3359 11.6667C13.3359 15.3486 16.3207 18.3333 20.0026 18.3333C23.6845 18.3333 26.6693 15.3486 26.6693 11.6667C26.6693 7.98477 23.6845 5 20.0026 5C16.3207 5 13.3359 7.98477 13.3359 11.6667Z",
    fill: "#C0D6F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6693 35C31.6693 28.5567 26.4459 23.3333 20.0026 23.3333C13.5593 23.3333 8.33594 28.5567 8.33594 35M20.0026 18.3333C16.3207 18.3333 13.3359 15.3486 13.3359 11.6667C13.3359 7.98477 16.3207 5 20.0026 5C23.6845 5 26.6693 7.98477 26.6693 11.6667C26.6693 15.3486 23.6845 18.3333 20.0026 18.3333Z",
    stroke: "#065EEA",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser01);
export default __webpack_public_path__ + "static/media/User_01.fd481030d9432b375e40526e9438850c.svg";
export { ForwardRef as ReactComponent };